import React from 'react';
import './Icon.scss';

interface IconBaseProps {
  x: number;
  y: number;
  size: number;
  symbol: string;
  color: string;
  onClick: (e: React.MouseEvent) => void;
}

const IconBase: React.FC<IconBaseProps> = ({
  x,
  y,
  size,
  symbol,
  color,
  onClick,
}) => (
  <g className="icon-base" onClick={onClick} style={{ cursor: 'pointer' }}>
    <rect
      x={x}
      y={y}
      width={size}
      height={size}
      rx={size / 2}
      fill="#fff"
      stroke={color}
      strokeWidth={2}
    />
    <text
      x={x + size / 2}
      y={y + size / 2 + 2}
      textAnchor="middle"
      dominantBaseline="middle"
      fill={color}
      fontSize={size * 0.7}
      fontWeight={700}
      pointerEvents="none">
      {symbol}
    </text>
  </g>
);

interface DeleteIconProps {
  cx: number;
  cy: number;
  r: number;
  onClick: (e: React.MouseEvent) => void;
}

export const DeleteIcon: React.FC<DeleteIconProps> = ({
  cx,
  cy,
  r,
  onClick,
}) => (
  <IconBase
    x={cx - r}
    y={cy - r}
    size={r * 2}
    symbol="×"
    color="#e74c3c"
    onClick={onClick}
  />
);

interface AddChildIconProps {
  x: number;
  y: number;
  width: number;
  height: number;
  onClick: (e: React.MouseEvent) => void;
}

export const AddChildIcon: React.FC<AddChildIconProps> = ({
  x,
  y,
  width,
  height,
  onClick,
}) => {
  const size = Math.max(width, height);
  return (
    <IconBase
      x={x}
      y={y}
      size={size}
      symbol="+"
      color="#4CAF50"
      onClick={onClick}
    />
  );
};
